import { Component, ElementRef, OnInit, Input, AfterViewInit  } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { DatePipe } from '@angular/common'
import { ModalDocumentoComponent } from "./modal-documento/modal-documento.component";
import { ActivatedRoute } from '@angular/router';
import { ComprobanteService } from "../DataAccess/comprobantes.service";


@Component({
  selector: "home-web",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.css"]
})
export class HomeWebComponent implements OnInit {
  @Input() inicio: true;

  public id: string = "";

  public flagMostrarModal!:boolean;

  constructor(private translate: TranslateService, public dialog: MatDialog, private route: ActivatedRoute, private generarComprobante:ComprobanteService) {
    this.id = this.route.snapshot.paramMap.get('id');
    this.existeIdItem()

  }

  loadAPI: Promise<any>
  setLanguage(lang: string) {
    this.translate.use(lang);
  }

  ngOnInit() {
    this.loadAPI = new Promise((resolve) => {
      this.loadScript();
      resolve(true);
    });
  }

  public loadScript() {
    var isFound = false;
    var scripts = document.getElementsByTagName("script")
    for (var i = 0; i < scripts.length; ++i) {
      if (scripts[i].getAttribute('src') != null && scripts[i].getAttribute('src').includes("loader")) {
        isFound = true;
      }
    }

    if (!isFound) {
      var dynamicScripts = ["https://unpkg.com/flickity@2/dist/flickity.pkgd.min.js"];

      for (var i = 0; i < dynamicScripts.length; i++) {
        let node = document.createElement('script');
        node.src = dynamicScripts[i];
        node.type = 'text/javascript';
        node.async = false;
        node.charset = 'utf-8';
        document.getElementsByTagName('head')[0].appendChild(node);
      }
    }
  }

  abrirModalDocumento(data?: any):void {
    const dialogRef = this.dialog.open(ModalDocumentoComponent, {
      panelClass: 'my-custom-dialog',
      height: 'auto',
      width: 'auto',
      data: {data}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('El modal fue cerrado');
    });
  }

  existeIdItem() {
    this.generarComprobante.existeId(this.id).subscribe(
      data => {
        console.log(data.data)
        console.log(data.exists)
        this.flagMostrarModal = data.exists
        console.log("esta variando", this.flagMostrarModal)

        if (this.flagMostrarModal) this.abrirModalDocumento(data);
      }, error => {
        console.log(error)
      }, () => { }
    )
  }

}
